import DOMPurify from "dompurify";

// Centralized sanitizer for any admin-authored HTML (bios, static pages).
// Allows common editorial tags + safe links (the admin panel is PIN-protected,
// but we still defend in depth against XSS if a PIN were ever compromised).
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "em", "i", "b", "u", "s",
    "a", "ul", "ol", "li", "blockquote",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "span", "div", "hr", "sup", "sub",
    "figure", "figcaption", "img",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class", "src", "alt", "title", "style"],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, CONFIG);
}

export function safeHtml(html) {
  return { __html: sanitizeHtml(html) };
}
